import { WidgetsDashboardMain } from '@/widgets/dashboard';

export const PagesDashboardMain = () => <WidgetsDashboardMain />;
